import { Routes } from '@angular/router';
import { provideMediaStore } from '@app/store/media';
import { ModalComponent } from '@shared/components';
import { AddComponent } from './add/add.component';
import { AddFormComponent } from './add/add-form/add-form.component';
import { ViewComponent } from './view/view.component';
import { EditComponent } from './edit/edit.component';

export const allMediaModalRoutes: Routes = [
    {
        path: 'media/add',
        component: ModalComponent,
        outlet: 'modal',

        children: [
            { path: 'select', component: AddComponent },
            { path: ':type', component: AddFormComponent },
        ],
    },
    {
        path: 'media/view/:id',
        component: ModalComponent,
        outlet: 'modal',

        providers: [...provideMediaStore()],
        children: [{ path: '', component: ViewComponent }],
    },
    {
        path: 'media/edit/:id',
        component: ModalComponent,
        outlet: 'modal',

        providers: [...provideMediaStore()],
        children: [{ path: '', component: EditComponent }],
    },
];
